<template>
    <div class="friendZoneButton">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="secondary"
                    icon
                    @click="goToFriendZone"
                    v-bind="attrs"
                    v-on="on">
                    <font-awesome-icon :icon="icon.friends" class="fa-lg" />
                </v-btn>
            </template>
            <span>Zone des amis</span>
        </v-tooltip>
    </div>
</template>

<script>
import { faUsers } from '@fortawesome/pro-light-svg-icons';

export default {
    data() {
        return {
            icon: {
                friends: faUsers
            }
        }
    },
    methods: {
        goToFriendZone() {
            this.$router.push({ name: 'FriendZone' }).catch(() => { });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>